import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { NotesHomeComponent } from './notes-home/notes-home.component';
import { ProceduresComponent } from './procedures/procedures.component';
import { CheckInComponent } from './check-in/check-in.component';
import { EstimatesComponent } from './estimates/estimates.component';
import { EstimatePageComponent } from './estimate-page/estimate-page.component';
import { NotesRecallComponent } from './notes-recall/notes-recall.component';
import { ClientComponent } from './client/client.component';
import { HistoryComponent } from './history/history.component';
import { ProfileComponent } from './profile/profile.component';
import { PetComponent } from './pet/pet.component';
import { InvoicingComponent } from './invoicing/invoicing.component'; 
import { LandingPageComponent } from './landing-page/landing-page.component';
import { NoPetPageComponent } from './no-pet-page/no-pet-page.component';
import { VitalSignComponent } from './vital-sign/vital-sign.component';
import { InvCasgregComponent } from './invoicing/inv-casgreg/inv-casgreg.component';


const routes: Routes = [{
    path: '',
    component: LandingPageComponent
}, {
    path: 'check-in',
    component: CheckInComponent
}, {
    path: 'procedures',
    component: NotesHomeComponent
}, {
    path: 'estimate',
    component: EstimatesComponent
}, {
    path: 'estimate-page',
    component: EstimatePageComponent
}, {
    path: 'notes-recall',
    component: NotesRecallComponent
}, {
    path: 'client',
    component: ClientComponent
}, {
    path: 'pet',
    component: PetComponent
}, {
    path: 'profile',
    component: ProfileComponent
}, {
    path: 'history',
    component: HistoryComponent
}, {
    path: 'invoice',
    component: InvoicingComponent
}, 
{
    path: 'no-pet-page',
    component: NoPetPageComponent
},
{
    path: 'vitalsign',
    component: VitalSignComponent
},
{
    path: 'inv-casgreg',
    component: InvCasgregComponent
}
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule],
})
export class WorkRoutingModule { }
